var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnologiesDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/cpu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cpu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M13 2H7C4.24 2 2 4.24 2 7V13C2 15.76 4.24 18 7 18H13C15.76 18 18 15.76 18 13V7C18 4.24 15.76 2 13 2ZM15.26 12.26C15.26 13.92 13.92 15.26 12.26 15.26H7.74C6.08 15.26 4.74 13.92 4.74 12.26V7.74C4.74 6.08 6.08 4.74 7.74 4.74H12.25C13.91 4.74 15.25 6.08 15.25 7.74V12.26H15.26Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.06006 0.75V2H7.00006C6.50006 2 6.02006 2.07 5.56006 2.21V0.75C5.56006 0.34 5.89006 0 6.31006 0C6.72006 0 7.06006 0.34 7.06006 0.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.75 0.75V2H9.25V0.75C9.25 0.34 9.59 0 10 0C10.41 0 10.75 0.34 10.75 0.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.45 0.75V2.21C13.99 2.07 13.5 2 13 2H12.95V0.75C12.95 0.34 13.29 0 13.7 0C14.11 0 14.45 0.34 14.45 0.75Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 6.30005C20 6.72005 19.67 7.05005 19.25 7.05005H18V7.00005C18 6.50005 17.93 6.01005 17.79 5.55005H19.25C19.67 5.55005 20 5.89005 20 6.30005Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20 10C20 10.41 19.67 10.75 19.25 10.75H18V9.25H19.25C19.67 9.25 20 9.58 20 10Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20 13.7C20 14.11 19.67 14.45 19.25 14.45H17.79C17.93 13.99 18 13.5 18 13V12.95H19.25C19.67 12.95 20 13.28 20 13.7Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.45 17.79V19.25C14.45 19.66 14.11 20 13.7 20C13.29 20 12.95 19.66 12.95 19.25V18H13C13.5 18 13.99 17.93 14.45 17.79Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.76 18V19.25C10.76 19.66 10.42 20 10.01 20C9.59001 20 9.26001 19.66 9.26001 19.25V18H10.76Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.06006 18V19.25C7.06006 19.66 6.72006 20 6.31006 20C5.89006 20 5.56006 19.66 5.56006 19.25V17.79C6.02006 17.93 6.50006 18 7.00006 18H7.06006Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.21 5.55005C2.07 6.01005 2 6.50005 2 7.00005V7.05005H0.75C0.34 7.05005 0 6.72005 0 6.30005C0 5.89005 0.34 5.55005 0.75 5.55005H2.21Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2 9.25V10.75H0.75C0.34 10.75 0 10.41 0 10C0 9.58 0.34 9.25 0.75 9.25H2Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.21 14.45H0.75C0.34 14.45 0 14.11 0 13.7C0 13.28 0.34 12.95 0.75 12.95H2V13C2 13.5 2.07 13.99 2.21 14.45Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.26 7.73999V12.25C15.26 13.91 13.92 15.25 12.26 15.25H7.73999C6.07999 15.25 4.73999 13.91 4.73999 12.25V7.73999C4.73999 6.07999 6.07999 4.73999 7.73999 4.73999H12.25C13.91 4.73999 15.26 6.08999 15.26 7.73999Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologiesDisabled);
export default __webpack_public_path__ + "static/media/technologiesDisabled.7874f8c6dd77df804d297ea05575a797.svg";
export { ForwardRef as ReactComponent };